<template>
  <div class="cart-form">
    <div class="rounded overflow-hidden bg-gradient-to-b light:(from-light-1 to-light-3) dark:(from-dark-1 to-dark-3)">
      <div class="flex items-center justify-between h-10 px-2 bg-secondary text-white">
        <div>선택폴더</div>
        <div>{{ cartStore.items.length }} 폴더</div>
      </div>
      <div class="cart-limits">
        <div
          v-for="item in list"
          class="cart-limit-item"
        >
          <div>{{ item.label }}</div>
          <div class="flex items-center gap-2 font-bold">
            <div>{{ item.value }}</div>
            <div>{{ item.unit }}</div>
          </div>
        </div>
      </div>
      <div class="m-2 flex flex-nowrap items-center rounded border dark:border-dark-4 light:border-light-4">
        <QInput
          v-model.number="cartStore.amount"
          outlined
          dense
          mask="###,###,###,###"
          unmasked-value
          reverse-fill-mask
          suffix="₩"
          class="font-bold"
        />
        <QBtn
          icon="refresh"
          size="md"
          flat
          color="secondary"
          class="py-1"
          @click="cartStore.amount = 0"
        />
      </div>
      <div class="m-2 grid grid-cols-3 gap-2">
        <QBtn
          v-for="btn in amountButtons"
          :label="btn.label"
          unelevated
          class="text-primary dark:bg-dark-1 light:bg-light-1"
          @click="cartStore.amount += btn.value"
        />
        <QBtn
          label="MAX"
          unelevated
          class="text-primary dark:bg-dark-1 light:bg-light-1"
          @click="inputMaxAmount"
        />
      </div>
      <div class="px-2">
        <QBtn
          label="배 팅"
          color="secondary"
          class="mt-2 w-full h-10"
          :loading="cartStore.submitting"
          @click="$emit('submit')"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import { useAuthStore } from '@/stores/auth.js'
import { useCartStore } from '@/stores/cart.js'
import { useSettingStore } from '@/stores/setting.js'
import { currency } from '@/utils'
import { divide, floor, multiply, reduce, round } from 'lodash-es'
import { computed } from 'vue'
import {useRoute} from "vue-router";

defineEmits(['submit'])

const authStore = useAuthStore()
const settingStore = useSettingStore()
const cartStore = useCartStore()
const route = useRoute()
const expectOdds = computed(() => route.name.includes('duotone-balls') ? 0 : round(reduce(cartStore.items, (result, value) => multiply(result, value.odds.v ?? value.odds.value), 1), 2))
const expectWinning = computed(() => currency(round(multiply(expectOdds.value, cartStore.amount))))

const list = computed(() => ({
  userAmount: {
    label: '보유머니',
    value: authStore.walletBalance,
    unit: '원'
  },
  minBettingAmount: {
    label: '최소배팅금액',
    value: settingStore.minBetAmount,
    unit: '원'
  },
  maxMultiBettingAmount: {
    label: '최대배팅금액',
    value: authStore.maxMultiBettingAmount,
    unit: '원'
  },
  expectOdds: {
    label: '예상배당률',
    value: expectOdds.value,
    unit: '배'
  },
  expectWinning: {
    label: '예상적중금',
    value: expectWinning.value,
    unit: '원'
  },
}))
const amountButtons = [
  {
    label: '오천',
    value: 5000
  },
  {
    label: '일만',
    value: 10000
  },
  {
    label: '오만',
    value: 50000
  },
  {
    label: '십만',
    value: 100000
  },
  {
    label: '백만',
    value: 1000000
  },
]

function inputMaxAmount () {
  if (cartStore.items.length > 1) {
    cartStore.amount = Math.min(
      authStore.user.wallet_balance,
      authStore.user.level_info.max_multi_betting_amount,
      floor(divide(authStore.user.level_info.max_multi_winning_amount, expectOdds.value))
    )
  } else {
    cartStore.amount = Math.min(
      authStore.user.wallet_balance,
      authStore.user.level_info.max_single_betting_amount,
      floor(divide(authStore.user.level_info.max_single_winning_amount, expectOdds.value))
    )
  }
}
</script>
